import styled from '@emotion/styled'
import { IconButton, TextField } from '@mui/material'
import { colors } from '@resiliatech/birdsong'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const SummaryContainer = styled.div`
  background-color: rgba(0, 63, 126, 0.04);
  border-radius: 8px;
  padding: 24px;
  position: relative;
`

export const EditButton = styled(IconButton)`
  position: absolute;
  top: 40px;
  right: 40px;
  background-color: ${colors.interactive.secondaryEnabled};
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid ${colors.primary.main};

  &:hover {
    background-color: #d5d5d5;
  }

  & .MuiSvgIcon-root {
    font-size: 20px;
    color: ${colors.primary.main};
  }
`

export const SummaryText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: ${colors.text.primary};
  margin: 0;
  max-width: calc(100% - 80px);
  padding: 16px;
  &:after {
    content: '';
    display: inline-block;
  }
`

export const InstructionText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: ${colors.text.secondary};
  margin: 0 0 16px 0;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  width: 100%;
  margin-top: auto;
`

export const StyledTextField = styled(TextField)`
  width: 100%;
  .MuiOutlinedInput-root {
    min-height: 120px;
  }
  margin-top: 8px;
`
